export type PurchaseOrderDisplayStatusInput = {
  status?: string | null;
  approvalRequired?: boolean | null;
  approvalStatus?: string | null;
};

export type PurchaseOrderDisplayStatusView = {
  text: string;
  color: string;
  icon: 'clock' | 'shoppingCart' | 'checkCircle' | 'exclamationCircle';
};

const orderStatusView: Record<string, PurchaseOrderDisplayStatusView> = {
  draft: { text: '下書き', color: 'default', icon: 'clock' },
  ordered: { text: '発注済み', color: 'processing', icon: 'shoppingCart' },
  partial: { text: '部分納品', color: 'warning', icon: 'exclamationCircle' },
  delivered: { text: '納品済み', color: 'success', icon: 'checkCircle' },
  cancelled: { text: 'キャンセル', color: 'error', icon: 'exclamationCircle' },
};

const approvalPendingView: PurchaseOrderDisplayStatusView = {
  text: '承認待ち',
  color: 'warning',
  icon: 'clock',
};

export function getPurchaseOrderDisplayStatusView(
  order: PurchaseOrderDisplayStatusInput,
): PurchaseOrderDisplayStatusView {
  if (order.approvalRequired && order.approvalStatus === 'pending') {
    return approvalPendingView;
  }

  return orderStatusView[order.status ?? 'draft'] ?? orderStatusView.draft;
}
